import { z } from 'zod';

// ─── Queue name constants shared between api and worker packages ──────────────
//
// Two queues, not one: `photo-derivative` handles per-photo jobs enqueued by
// the API right after a create/edit upload commits, while
// `photo-derivative-backfill` handles the one-off admin-triggered sweep over
// pre-existing photos. Kept separate so a multi-hour backfill never delays
// renditions for a photo a user just uploaded. Both queues call the same
// rendition-generation helper in the worker — see proposal.md "Queue split".

export const PHOTO_DERIVATIVE_QUEUE_NAME = 'photo-derivative';
export const PHOTO_DERIVATIVE_BACKFILL_QUEUE_NAME = 'photo-derivative-backfill';

// ─── Admin-triggered backfill trigger response ─────────────────────────────────
//
// Mirrors AdminBoundaryImportTriggerResponseSchema — POST /admin/photos/backfill-derivatives
// enqueues a job and returns its id immediately.

export const PhotoDerivativeBackfillTriggerResponseSchema = z.object({
  jobId: z.string(),
});

export type PhotoDerivativeBackfillTriggerResponse = z.infer<
  typeof PhotoDerivativeBackfillTriggerResponseSchema
>;
